module.exports = {
    "collapse": `R\xe9duire`,
    "expand": `D\xe9velopper`
};


//# sourceMappingURL=fr-FR.main.js.map
